import PDFSeriesTable from './PDFSeriesTable';

import PDFTable from './PDFTable';
import PDFTableHead from './PDFTableHead';
import PDFTableBody from './PDFTableBody';
import PDFTableRow from './PDFTableRow';
import PDFTableCell from './PDFTableCell';

export {
  PDFSeriesTable,
  PDFTable,
  PDFTableHead,
  PDFTableBody,
  PDFTableRow,
  PDFTableCell
};

export default PDFSeriesTable;
